/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Groupsmessagedelete2Inputs */

const en_groupsmessagedelete2 = /** @type {(inputs: Groupsmessagedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete message`)
};

const de_groupsmessagedelete2 = /** @type {(inputs: Groupsmessagedelete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht löschen`)
};

/**
* | output |
* | --- |
* | "Delete message" |
*
* @param {Groupsmessagedelete2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupsmessagedelete2 = /** @type {((inputs?: Groupsmessagedelete2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupsmessagedelete2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupsmessagedelete2(inputs)
	return de_groupsmessagedelete2(inputs)
});
export { groupsmessagedelete2 as "groupsMessageDelete" }